import React, { useEffect, useState } from 'react'
import { registerEvent } from './eventRegistrySingleton';

type Props = {}

const EventUserExample = (props: Props) => {
  const [show, setShow] = useState(false);
  const [count] = useState(0);
  useEffect(() => {
    registerEvent("Escape", "Hello", () => {
      console.log("Hello from event", show);
      exampleFunction();
      setShow(!show);
    });
    registerEvent("Click", "HelloClick", () => {
      console.log("Hello from Click event", show);
      exampleFunction();
      setShow(!show);
    });
    registerEvent("mousemove", "HelloClick", () => {
      exampleFunctionMouse();
    });
  }, [show, count])


  function exampleFunction() {
    //setCount(count + 1);
    //console.warn("example warning from the function of the component")
  }

  function exampleFunctionMouse() {
    //setCount(count + 1);
    //console.warn("example warning from the function mouse of the component")
  }

  // return (
  //   <div style={{
  //     color: "red",
  //     position: "absolute",
  //     zIndex: "5000",
  //     marginLeft: "25%"
  //   }}>{show ? "TRUE" : "FALSE"} EventUserExample, count: {count}</div>
  // )

  return (
    <></>
  )
}

export default EventUserExample